import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../Components/Layout/Layout";
import Students from "./Students";
import Teachers from "./Teachers";
import Users from "./Users";
import Gallery from "./Gallery";
import { getFilters } from "../../redux/actions/dashboard";
import "./style.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./responsive.css";
import GuestModal from "../../Components/GuestModal";
import { setGuestModal } from "../../redux/actions/auth";

const Home = () => {

  const dispatch = useDispatch();

  const guestModal = useSelector(state => state.auth.guestModal);
  const showDemo = useSelector(state => state.auth.showDemo);
  const filters = useSelector((state) => state.dashboard.filters);

  const [show, setShow] = useState(true);

  useEffect(() => {
    dispatch(getFilters());
  }, []);

  const handleGuestModal = state => {
    setShow(false);
    dispatch(setGuestModal(false))
  }

  return (
    <Layout title="Dashboard" page="dashboard">
      {localStorage.guest && guestModal && showDemo && <GuestModal show={show} handleClose={handleGuestModal} />}
      <div className="m-top-3"><div className="page-title"><h2>Dashboard</h2></div></div>
      <div className="top-tab-btns">
        <Tabs defaultActiveKey="performance_tab" className="mb-4  top-tab-ul ps-3 ps-sm-4">
          <Tab eventKey="performance_tab" title="Performance Summary">
            <div className="performace-tab-inr">
              <Tabs defaultActiveKey="Student-tab-pane" className="mb-0">
                {filters?.filterLevel?.map((item, index) => {
                  return (
                    <Tab eventKey={`${item}-tab-pane`} title={item}>
                      {item == "Student" ? (
                        <Students />
                      ) : item == "Teachers" ? (
                        <Teachers />
                      ) : (
                        <Users />
                      )}
                    </Tab>
                  );
                })}
              </Tabs>
            </div>
          </Tab>
          <Tab eventKey="gallery_tab" title="Gallery">
            <Gallery />
          </Tab>
        </Tabs>
      </div>
    </Layout>
  );
};

export default Home;
